// @flow
import React, { useEffect, Suspense } from 'react'
import { useSelector } from 'react-redux'
import { Outlet } from 'react-router-dom'

// utils
import { changeBodyAttribute } from '../utils'

const loading = () => <div className='' />

const InfotoolsLayout = () => {
  const { layoutColor } = useSelector((state) => ({
    layoutColor: state.Layout.layoutColor
  }))

  useEffect(() => {
    changeBodyAttribute('data-layout-color', layoutColor)
  }, [layoutColor])

  return (
    <Suspense fallback={loading()}>
      <Outlet />
    </Suspense>
  )
}
export default InfotoolsLayout
